var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "schoolWarp" },
    [
      _c("ZhjySerach", {
        attrs: { queryGroup: _vm.queryGroup, modelData: _vm.modelData },
        on: {
          "update:modelData": function ($event) {
            _vm.modelData = $event
          },
          "update:model-data": function ($event) {
            _vm.modelData = $event
          },
          search: _vm.search,
        },
      }),
      _vm._v(" "),
      _c("FunBtn", {
        attrs: {
          defaultColumn: _vm.defaultColumn,
          funBtns: _vm.funBtns,
          isShowSelectChange: true,
        },
        on: { add: _vm.add },
      }),
      _vm._v(" "),
      _c("ZhjyTable", {
        attrs: {
          minWidth: _vm.minWidth,
          tableData: _vm.listData,
          columList: _vm.defaultColumn,
          isShowSelection: true,
          pageNum: _vm.page.pageNumber,
          pageSize: _vm.page.pageSize,
          formatters: _vm.formatters,
          options: _vm.options,
          sort: _vm.sort,
        },
        on: {
          "update:pageNum": function ($event) {
            return _vm.$set(_vm.page, "pageNumber", $event)
          },
          "update:page-num": function ($event) {
            return _vm.$set(_vm.page, "pageNumber", $event)
          },
          handleSelectionChange: _vm.handleSelectionChange,
          add: _vm.add,
          editLogo: _vm.editLogo,
          "update:sort": function ($event) {
            _vm.sort = $event
          },
          delete: _vm.deleteConfig,
        },
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogShow,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogShow = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.typeConfigParam, "label-width": "80px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "名称", prop: "keyData" } },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.isDisabled,
                      placeholder: "请输入名称",
                    },
                    model: {
                      value: _vm.typeConfigParam.keyData,
                      callback: function ($$v) {
                        _vm.$set(_vm.typeConfigParam, "keyData", $$v)
                      },
                      expression: "typeConfigParam.keyData",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "值", prop: "valueData" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入值" },
                    model: {
                      value: _vm.typeConfigParam.valueData,
                      callback: function ($$v) {
                        _vm.$set(_vm.typeConfigParam, "valueData", $$v)
                      },
                      expression: "typeConfigParam.valueData",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "类型", prop: "businessType" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        disabled: _vm.isDisabled,
                        placeholder: "请输入岗位状态",
                      },
                      model: {
                        value: _vm.typeConfigParam.businessType,
                        callback: function ($$v) {
                          _vm.$set(_vm.typeConfigParam, "businessType", $$v)
                        },
                        expression: "typeConfigParam.businessType",
                      },
                    },
                    _vm._l(_vm.typeList, function (item) {
                      return _c("el-option", {
                        key: item.valueData,
                        attrs: { value: item.valueData, label: item.keyData },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.handleReset()
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handleSubmit()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }